var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0h357c14 0 25 11 25 25v230c0 14-11 26-25 26H264v14h24c5 0 10 2 13 6 4 3 6 8 6 13 0 6-2 11-6 14-3 4-8 6-13 6H119c-6 0-10-2-14-6-3-3-6-8-6-14 0-5 3-10 6-13 4-4 8-6 14-6h23v-14H25c-14 0-26-12-26-26V25C-1 11 11 0 25 0zm177 235c7 0 12 5 12 12 0 6-5 11-12 11-6 0-11-5-11-11 0-7 5-12 11-12zm42 60v-14h-82v14h82zM11 358h385c3 0 5 1 7 3s3 4 3 7v28c0 3-1 5-3 7s-4 3-7 3H11c-3 0-6-1-8-3s-3-4-3-7v-28c0-3 1-5 3-7s5-3 8-3zm379-108v-25H14v25c0 4 2 8 5 11s7 5 11 5h345c4 0 8-2 11-5 2-3 4-7 4-11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoTheme);
export default __webpack_public_path__ + "static/media/AutoTheme.71c41ac369bd99696b02c2c5a328cc8e.svg";
export { ForwardRef as ReactComponent };